export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--only">
        <div className="about-containers">
          <div className="details-container">
            <img
              src="./img/experience.png"
              alt="Experience icon"
              className="icon"
            />
            <h3>Experience</h3>
            <p>
              - Frontend Developer (7 months) <br />- Service Desk Analyst (4
              months)
            </p>
          </div>
        </div>
        <div className="about-containers">
          <div className="details-container">
            <img
              src="./img/education.png"
              alt="Education icon"
              className="icon"
            />
            <h3>Education</h3>
            <p>
              Bachelor of Computer Science <br />
              (Software Development)
            </p>
          </div>
        </div>
      </div>

      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
            I am a Service Desk Analyst at Swinburne University of Technology,
            where I provide timely and effective technical support to internal
            and external stakeholders. In this role, I use my communication,
            problem-solving, and technical skills to identify and resolve
            technology-related issues, ensuring a smooth and seamless user
            experience.
          </p>
          <p className="hero--section-description">
            I am also a Computer Science Student at Swinburne, with a passion
            for front-end development. As part of my degree, I have learned
            various programming languages, such as C/C++, C#, Kotlin, Python,
            JavaScript, and PHP, and applied them to different projects.
          </p>
          <p className="hero--section-description">
            Additionally, I have gained valuable hands-on experience as an
            intern at 99AuPairs, where I contributed to the development of
            cutting-edge web applications using tools and technologies such as
            Zoho CRM, GoDaddy, and WordPress.
          </p>
        </div>
      </div>
    </section>
  );
}
